<template>
  <div>
    <MobialisFormWithValidation v-slot="{ invalid, errors }" @onValidate="submit">
      <div class="row">
        <div class="col-sm-7">
          <Hero>
            <h2 class="mr-5">
              {{ $t('message.testDrive.preferencesHeader')
              }}<img :src="require('@/assets/fa/handshake.svg')" width="22" height="22" class="mb-1 ml-2" alt="" />
            </h2>
            <template slot="description">{{ $t('message.testDrive.preferencesDescription') }}</template>
          </Hero>
          <mobialis-selection-input-with-validation
            :label="$t('message.testDrive.preferencesSubheader1')"
            vid="language"
            :options="availableLanguages"
            v-model="setLanguage"
            data-cy="language"
          />
          <div v-if="givenGenders.length > 1">
            <h5 class="mt-4 mb-0 form-label">{{ $t('message.testDrive.preferencesSubheader2') }}</h5>
            <p class="error" v-if="invalid">
              {{ $t('message.testDrive.errorMessagePartOne') }}{{ $t('message.testDrive.errorMessagePartTwo')[2] }}
            </p>
            <MobialisFancyRadio
              :textArray="availableGenders"
              name="gender"
              v-model="setGender"
              data-cy="gender"
            ></MobialisFancyRadio>
          </div>
        </div>
        <div class="col-sm-5">
          <DriveTip class="mt-4 mt-sm-2 tip-container">
            <template slot="description">{{ $t('message.testDrive.preferencesDriveTip') }}</template>
          </DriveTip>
        </div>
      </div>
      <mobialis-button class="mt-3 mt-sm-5" data-cy="continueBtn">{{ $t('message.common.continue') }}</mobialis-button>
    </MobialisFormWithValidation>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import Hero from '@/components/test-drive/Hero.vue';
import log from '@/services/log';
import DriveTip from '@/components/test-drive/DriveTip.vue';

export default {
  name: 'Preferences',
  components: {
    Hero,
    DriveTip,
  },
  data() {
    return {
      languages: this.$t('message.common.languages'),
      genders: this.$t('message.common.genders'),
      givenLanguages: [],
      givenGenders: [],
      noPreference: {
        label: this.$t('message.testDrive.genderNoPreference'),
        value: 'no_preference',
      },
    };
  },
  computed: {
    ...mapGetters('testDrive', ['isFromHomeRoute']),
    setLanguage: {
      get() {
        return this.$store.state.testDrive.chosenLanguage;
      },
      set(value) {
        this.$store.commit('testDrive/SET_CHOSEN_LANGUAGE', value);
      },
    },
    setGender: {
      get() {
        return this.$store.state.testDrive.chosenGender;
      },
      set(value) {
        this.$store.commit('testDrive/SET_CHOSEN_GENDER', value);
      },
    },
    availableLanguages() {
      // this takes the list of languages from the backend and creates an array of objects based off of that list
      return this.languages.filter(item => this.givenLanguages.indexOf(item.value) !== -1);
    },
    availableGenders() {
      // this takes the list of genders from the backend and creates an array of objects based off of that list
      const holder = this.genders.filter(item => this.givenGenders.indexOf(item.value) !== -1);
      holder.push(this.noPreference);
      return holder;
    },
  },
  methods: {
    submit(isValid) {
      if (isValid) {
        if (this.isFromHomeRoute) {
          this.$router.push({
            name: `drive-important-features-${this.baseRoute}`,
          });
        } else {
          this.$router.push({
            name: `drive-pick-route-${this.baseRoute}`,
          });
        }
      }
    },
  },
  async created() {
    try {
      this.$store.commit('SET_LOADING', true);
      await this.$store.dispatch('testDrive/getTestDriveSettings');
    } catch (error) {
      log('Error in Test Drive settings retrieval', error);
    } finally {
      this.$store.commit('SET_LOADING', false);
    }
    const { languageOptions, genderOptions } = this.$store.state.testDrive.settings;
    // Set a default language when it's empty
    this.givenLanguages = languageOptions.length === 0 ? ['english'] : languageOptions; // getting a list of languages sent from the backend
    this.givenGenders = genderOptions; // getting a list of genders sent from the backend
    this.setLanguage = this.$store.state.user.language === 'en_FR' ? 'french' : 'english';
  },
};
</script>
